import { renderBlock } from "./blockRegistry";

const CommonBlockRenderer = ({ blocks, section }) => {
  const resolvedBlocks = blocks ?? section?.blocks;

  if (!resolvedBlocks?.length) {
    return null;
  }

  return resolvedBlocks.map(renderBlock);
};

export default CommonBlockRenderer;
